import { MarketComparisonWritable } from 'api';

const matchesCapIqId
  = (id: string) =>
    (comparison: MarketComparisonWritable): boolean =>
      comparison.cap_iq_id === id;

export default matchesCapIqId;
